import { Action, applyMiddleware, createStore } from "redux";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import thunk, { ThunkAction } from "redux-thunk";
import rootReducer from "../reducers/root";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

// export default function configureStore(initialState = {}) {
//   return createStore(rootReducer, initialState, applyMiddleware(thunk));
// }
export default function createStoreApp(initialState = {}) {
  return configureStore({
    reducer: rootReducer,
    middleware: [
      ...getDefaultMiddleware({
        serializableCheck: false,
      }),
      thunk,
    ],
  });
}

const store = createStoreApp();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
export const dispatch = store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
